import {
  GET_BLOCK_TEMPLATE_SUCCESS,
  GET_BLOCK_TEMPLATE_FAIL,
  ADD_BLOCK_TEMPLATE_SUCCESS,
  ADD_BLOCK_TEMPLATE_FAIL,
  UPDATE_BLOCK_TEMPLATE_SUCCESS,
  UPDATE_BLOCK_TEMPLATE_FAIL,
  DELETE_BLOCK_TEMPLATE_SUCCESS,
  DELETE_BLOCK_TEMPLATE_FAIL,
  RESET_BLOCK_TEMPLATE_RESULTS,
  type AvailableActions,
  GET_BLOCK_TEMPLATES_FAIL,
  GET_BLOCK_TEMPLATES_SUCCESS,
  GET_BLOCK_TEMPLATES_PENDING,
  GET_BLOCK_TEMPLATE_PENDING,
  ADD_BLOCK_TEMPLATE_PENDING,
  UPDATE_BLOCK_TEMPLATE_PENDING,
  DELETE_BLOCK_TEMPLATE_PENDING,
} from '@plone-collective/volto-editortemplates/actions/blocks-templates';
import type { TemplatesRequestRespose } from '@plone-collective/volto-editortemplates/types';
import { omit } from 'lodash';

interface BlockTemplatesState {
  templates: TemplatesRequestRespose['items'];
  actions: TemplatesRequestRespose['actions'];
  loading: boolean;
  error: string | null;
  subrequests?: Record<string, Omit<BlockTemplatesState, 'subrequests'>>;
}

interface Action {
  type: AvailableActions;
  result: TemplatesRequestRespose;
  error: string | null;
  subrequest?: any;
}

const initialState: BlockTemplatesState = {
  templates: [],
  actions: { can_delete_templates: false },
  loading: false,
  error: null,
  subrequests: {},
};

function blockTemplatesReducer(
  state = initialState,
  action: Action,
): BlockTemplatesState {
  switch (action.type) {
    case GET_BLOCK_TEMPLATES_PENDING:
    case GET_BLOCK_TEMPLATE_PENDING:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests[action.subrequest] || {
                  ...initialState,
                }),
                error: null,
                loading: true,
              },
            },
            loading: true,
          }
        : {
            ...state,
            error: null,
            loading: true,
          };

    case GET_BLOCK_TEMPLATE_SUCCESS:
    case GET_BLOCK_TEMPLATES_SUCCESS:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests?.[action.subrequest] || {
                  ...initialState,
                }),
                error: null,
                loading: false,
                templates: action.result.items,
                actions: action.result.actions,
              },
            },
          }
        : {
            ...state,
            error: null,
            loading: false,
            templates: action.result.items,
            actions: action.result.actions,
          };

    case GET_BLOCK_TEMPLATES_FAIL:
    case GET_BLOCK_TEMPLATE_FAIL:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...state.subrequests[action.subrequest],
                error: action.error,
                loading: false,
                templates: initialState.templates,
                actions: initialState.actions,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            loading: false,
            templates: initialState.templates,
            actions: initialState.actions,
          };

    case ADD_BLOCK_TEMPLATE_PENDING:
    case UPDATE_BLOCK_TEMPLATE_PENDING:
    case DELETE_BLOCK_TEMPLATE_PENDING:
      return { ...state, loading: true };

    case ADD_BLOCK_TEMPLATE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        templates: [...state.templates],
        actions: state.actions,
      };

    case UPDATE_BLOCK_TEMPLATE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        templates: state.templates,
        actions: state.actions,
      };

    case DELETE_BLOCK_TEMPLATE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        templates: state.templates,
        actions: state.actions,
      };

    case ADD_BLOCK_TEMPLATE_FAIL:
    case UPDATE_BLOCK_TEMPLATE_FAIL:
    case DELETE_BLOCK_TEMPLATE_FAIL:
      return { ...state, loading: false, error: action.error };

    case RESET_BLOCK_TEMPLATE_RESULTS:
      return action.subrequest
        ? {
            ...initialState,
            subrequests: omit(state.subrequests, [action.subrequest]),
          }
        : { ...initialState };
    default:
      return state;
  }
}

export { blockTemplatesReducer };
export type { BlockTemplatesState };
